import { Button } from '@/components/ui/button'

export function PremiumCTA() {
  return (
    <div
      className="inline-block group relative bg-gradient-to-b from-black/10 to-white/10 
                        dark:from-white/10 dark:to-black/10 p-px rounded-[var(--radius-lg)] backdrop-blur-lg 
                        overflow-hidden transition-shadow duration-[time:var(--t-spring)]"
    >
      <Button
        variant="ghost"
        className="rounded-[1.15rem] px-8 py-6 text-lg font-semibold backdrop-blur-md 
                            bg-white/95 hover:bg-white/100 dark:bg-black/95 dark:hover:bg-black/100 
                            text-black dark:text-white transition-all duration-[time:var(--t-spring)] 
                            group-hover:-translate-y-0.5 border border-black/10 dark:border-white/10
                            dark:hover:shadow-neutral-800/50"
      >
        <span className="opacity-90 group-hover:opacity-100 transition-opacity">Discover Excellence</span>
        <span
          className="ml-3 opacity-70 group-hover:opacity-100 group-hover:translate-x-1.5 
                                transition-all duration-[time:var(--t-spring)]"
        >
          →
        </span>
      </Button>
    </div>
  )
}
